<template>
  <div>
    <v-container fluid v-if="hasCompanies()">
      <v-row align-start wrap v-if="isIndustriesSearch()">
        <v-col cols="12" class="industries-search-title pa-2">
          <div class="display-30-24 bold">{{getString(searchData, 'CompaniesLobby_Search_IndustryTitleFormat').Value}}</div>
        </v-col>
      </v-row>
      <v-row align-start wrap>
        <v-col
          cols="12"
          v-for="(company, index) in getCompanies"
          :key="index"
          class="promoted-company-item pa-2"
          md="4"
          sm="6"
        >
          <PromotedTip :company="company" :constants="constants" />
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="2">
          <v-btn
            v-if="isPaging()"
            class="orange_btn_large next-paging d-flex noUnderline m-auto"
            @click="loadMoreCompanies"
            :loading="isLoading"
          >{{getString(searchData, 'CompaniesLobby_Search_LoadMore').Value}}</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid v-else>
      <v-row align-start wrap>
        <v-col cols="12" class="no-company-item pa-2">
          <div class="display-18">
            {{ getString(searchData, 'CompaniesLobby_Search_NoResults').Value }}
            </div>
          <div class="display-18">
            {{ getString(searchData, 'CompaniesLobby_Search_TryAgain').Value }}
            </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import TipsWrapperBaseVue from './mixins/TipsWrapperBase.vue'

export default {
  mixins: [TipsWrapperBaseVue]
}
</script>
